import { Wallet, ExternalLink, Copy, Check } from "lucide-react";
import { useState } from "react";

interface WalletBadgeProps {
  address?: string;
  explorerUrl?: string;
}

export function WalletBadge({ address, explorerUrl }: WalletBadgeProps) {
  const [copied, setCopied] = useState(false);

  if (!address) {
    return null;
  }

  const truncatedAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
  const explorerLink = explorerUrl ? `${explorerUrl}/address/${address}` : undefined;

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
    }
  };

  const handleExplorerClick = () => {
    if (explorerLink) {
      window.open(explorerLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={handleExplorerClick}
        className="flex items-center gap-2 px-3 py-1.5 bg-white/10 rounded-lg hover:bg-white/20 transition-colors text-white"
        title={explorerLink ? "Ver no explorer" : "Endereço blockchain"}
      >
        <Wallet className="w-4 h-4" />
        <span className="font-mono text-sm">{truncatedAddress}</span>
        {explorerLink && <ExternalLink className="w-3 h-3 opacity-70" />}
      </button>
      <button
        onClick={handleCopy}
        className="p-1.5 bg-white/10 rounded-lg hover:bg-white/20 transition-colors text-white"
        title="Copiar endereço"
      >
        {copied ? (
          <Check className="w-4 h-4 text-green-400" />
        ) : (
          <Copy className="w-4 h-4 opacity-70" />
        )}
      </button>
    </div>
  );
}
